export const HexagonIcon = (
  <svg
    viewBox="-1 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    id="icon-hexagon"
  >
    <path
      d="M2.39206 21.6577C2.00143 21.4299 1.66371 21.1857 1.37888 20.9253C1.10218 20.6567 0.890594 20.3231 0.74411 19.9243C0.597626 19.5174 0.524384 19.0007 0.524384 18.374V8.93799C0.524384 8.3195 0.597626 7.81494 0.74411 7.42432C0.890594 7.03369 1.09811 6.71224 1.36667 6.45996C1.63522 6.20768 1.95668 5.97575 2.33102 5.76416L10.644 0.966797C11.4253 0.511068 12.2024 0.279134 12.9756 0.270996C13.7487 0.262858 14.5381 0.494792 15.3437 0.966797L23.6689 5.76416C24.027 5.97575 24.3403 6.20768 24.6089 6.45996C24.8855 6.71224 25.0971 7.03369 25.2436 7.42432C25.3901 7.81494 25.4633 8.3195 25.4633 8.93799V18.374C25.4633 19.0007 25.386 19.5174 25.2314 19.9243C25.0849 20.3231 24.8733 20.6567 24.5966 20.9253C24.32 21.1857 23.9863 21.4299 23.5957 21.6577L15.2949 26.4429C13.7568 27.3218 12.2228 27.3218 10.6928 26.4429L2.39206 21.6577Z"
      fill="currentColor"
    />
  </svg>
);
